import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98b46890"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel",
  style: {"gap":"8px"}
}
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Mail Template", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Variables", -1))
const _hoisted_5 = { class: "save-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_IciButton = _resolveComponent("IciButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.selectedTemplate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
        options: _ctx.templates,
        optionLabel: "key",
        placeholder: "Select Template ...",
        class: "md:w-14rem level-ddl ddl-field"
      }, null, 8, ["modelValue", "options"])
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createVNode(_component_Textarea, {
        modelValue: _ctx.selectedTemplate.template,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTemplate.template) = $event)),
        rows: "10",
        cols: "150"
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_4,
    _createElementVNode("div", null, [
      _createVNode(_component_Textarea, {
        modelValue: _ctx.selectedTemplate.variables,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTemplate.variables) = $event)),
        rows: "10",
        cols: "150"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_IciButton, {
        id: "submit",
        content: "Save",
        onButtonClick: this.save,
        btnStyle: "width: 140px;",
        dark: true
      }, null, 8, ["onButtonClick"])
    ])
  ]))
}